import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { reportsPost } from "../../store/reports/actions";
export var useApiPostReports = function (trigger, reportBody, onResetTrigger) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        loadingReports: state.Reports.loadingReports,
        responseReports: state.Reports.responseReports,
        errorReports: state.Reports.errorReports,
    }); }), loadingReports = _a.loadingReports, responseReports = _a.responseReports, errorReports = _a.errorReports;
    useEffect(function () {
        if (trigger) {
            dispatch(reportsPost(reportBody));
        }
        if (onResetTrigger)
            onResetTrigger();
    }, [trigger, reportBody]);
    return {
        loadingReports: loadingReports,
        responseReports: responseReports,
        errorReports: errorReports,
    };
};
